import { useNavigate, useParams } from "react-router-dom";

import { FinancePaymentRequestDetailFeaturePage } from "..";

/** 请款详情页面：请款单 ID 放在地址上。 */
export function FinancePaymentRequestDetailPage() {
  const { requestId = "" } = useParams();
  const navigate = useNavigate();
  return (
    <FinancePaymentRequestDetailFeaturePage
      key={requestId}
      requestId={requestId}
      onBack={() => navigate("/finance/payment-requests")}
    />
  );
}
